import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { DisplayColumn } from '../../services/global/global-interfaces';
import { PermissionService } from '../../services/permission.service';
import { RoutingID } from '../../routes/sb-routing-enum';

@Component({
  selector: 'sb-comp-dynamic-table-element',
  templateUrl: './dynamic-table-element.component.html',
  styleUrl: './dynamic-table-element.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicTableElementComponent implements OnInit {
  protected readonly permissionService = inject(PermissionService);
  protected readonly RoutingID = RoutingID;

  @Input({ required: true }) displayColumn: DisplayColumn; // needs to be any e.g. DeviceDTO, LocationDTO, CompanyDTO, ProductDTO, etc
  @Input() isInIntegratedContext: boolean = false;

  ngOnInit() {
    if (!this.displayColumn) {
      throw new Error('Type must be defined!');
    }
  }
}
